import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  TextField,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { UserRegistration } from '../../Models/UserRegistration';
import { Autocomplete } from '@material-ui/lab';
import { TitleCard } from '../../base/TitleCard';
import { maskCnpj, maskCpf } from '../../utils/masks';
import HomeIcon from '@material-ui/icons/Home';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import api from '../../service/api';
import { maskPhone } from '../../utils/masks';

const useStyles = makeStyles((theme) => ({
  paperWrap: {
    padding: theme.spacing(2),
    margin: theme.spacing(4),
  },
  form: {
    margin: theme.spacing(0),
    minWidth: '100%',
  },
}));

const UserRegistrationComponent = ({ location }: any) => {
  let history = useHistory();
  let [tipoPessoa, setTipoPessoa] = useState<string>('F');
  let [nome, setName] = useState<string>('');
  let [email, setEmail] = useState<string>('');
  let [cnpj, setCnpj] = useState<string>('');
  let [celular, setPhone] = useState<string>('');
  let [idPerfilUsuario, setIdPerfilUsuario] = useState<number>();
  let [idUnidadeNegocio, setIdUnidadeNegocio] = useState<number>();
  let [userNewcon, setuserNewcon] = useState<string>();
  let [senhaNewcon, setSenhaNewcon] = useState<string>();
  let [loginNewcon, setLoginNewcon] = useState<string>();
  let [dataNascimento, setDataNascimento] = useState('');
  let [loginWatchDoc, setLoginWatchDoc] = useState<string>();
  let [cpf, setCpf] = useState<string>('');
  let [inputValue, setInputValue] = React.useState<string | null>('');

  const [appProfileList] = useState<any[]>(location.state.appProfileList ?? []);
  const [loading, setLoading] = useState(false);

  const [businessUnitList] = useState<any[]>(
    location.state.businessUnitList ?? []
  );
  const [pontoVendaTitleList] = useState<any[]>(
    location.state.pontoVendaTitleList ?? []
  );

  const handleCreate = () => {
    setLoading(true);
    var idpv = null;
    for (var item of pontoVendaTitleList) {
      if (item.titulo === inputValue) {
        idpv = item.id;
        break;
      }
    }

    let user: UserRegistration = {
      tipoPessoa: tipoPessoa ?? '',
      nome: nome ?? '',
      email: email ?? '',
      cnpj: cnpj ? cnpj : null,
      cpf: cpf ? cpf : null,
      dataNascimento: dataNascimento ? dataNascimento : null,
      idPerfilUsuario: idPerfilUsuario ?? 0,
      celular: celular ?? '',
      idUnidadeNegocio: idUnidadeNegocio ?? 0,
      idPontoVenda: idpv,
      usuarioNewcon: userNewcon ?? '',
      senhaNewcon: senhaNewcon ?? '',
      loginNewcon: loginNewcon ?? '',
      loginWatchDoc: loginWatchDoc ?? '',
    };

    api.post('/Users/UserDataRegister', user).then(() => {
      history.push('/Sistema/Users');
    });

    setLoading(false);
  };

  useEffect(() => {
    setCpf(maskCpf(cpf));
  }, [cpf]);

  useEffect(() => {
    setCnpj(maskCnpj(cnpj));
  }, [cnpj]);

  useEffect(() => {
    setPhone(maskPhone(celular));
  }, [celular]);

  useEffect(() => {
    tipoPessoa === 'F' ? setCnpj('') : setCpf('');
  }, [tipoPessoa]);

  const classes = useStyles();

  return (
    <Box>
      <TitleCard
        buttonLink="/Sistema/Users"
        breadcrumbsIcon={<HomeIcon />}
        breadcrumbsText="Usuários"
      >
        <FileCopyIcon /> Cadastro de Usuários
      </TitleCard>

      <Paper className={classes.paperWrap}>
        <Grid container spacing={5}>
          <Grid item xs={6} sm={12}>
            <FormControl>
              <InputLabel id="demo-simple-select-label" required>
                Tipo Pessoa
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={tipoPessoa}
                onChange={(e) => setTipoPessoa(e.target.value as string)}
                label="Tipo Pessoa *"
              >
                <MenuItem value={'F'}>Pessoa Física</MenuItem>
                <MenuItem value={'J'}>Pessoa Jurídica</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              id="name"
              name="lastName"
              label="Nome"
              fullWidth
              autoComplete="Name"
              value={nome}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              id="e-mail"
              name="e-mail"
              label="E-mail"
              fullWidth
              autoComplete="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>

          {tipoPessoa === 'F' && (
            <>
              <Grid item xs={6}>
                <TextField
                  required
                  id="CPF"
                  name="CPF"
                  label="CPF"
                  fullWidth
                  autoComplete="CPF"
                  value={cpf}
                  onChange={(e) => setCpf(e.target.value)}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  required
                  InputLabelProps={{ shrink: true }}
                  name="dataDeNascimento"
                  label="Data de Nascimento"
                  type="date"
                  value={dataNascimento}
                  onChange={(e) => setDataNascimento(e.target.value)}
                />
              </Grid>
            </>
          )}

          {tipoPessoa === 'J' && (
            <Grid item xs={12}>
              <TextField
                required
                id="CPNJ"
                name="CPNJ"
                label="CPNJ"
                fullWidth
                autoComplete="CPNJ"
                value={cnpj}
                onChange={(e) => setCnpj(e.target.value)}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <FormControl className={classes.form}>
              <InputLabel required id="LabelPU">
                Perfil APP
              </InputLabel>
              <Select
                id="idPerfilUsuario"
                value={idPerfilUsuario}
                onChange={(e) => setIdPerfilUsuario(e.target.value as number)}
                name="idPerfilUsuario"
                label="Perfil APP *"
              >
                {appProfileList.map((row: any) => (
                  <MenuItem
                    value={row.id}
                  >{`${row.nome} - ${row.tipoPerfil}`}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              required
              id="telefone"
              name="telefone"
              label="Telefone"
              fullWidth
              autoComplete="Telefone"
              value={celular}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl className={classes.form}>
              <InputLabel required id="LabelUD">
                Unidade Negócio
              </InputLabel>
              <Select
                labelId="Unidade Negócio"
                id="unidadeNegocio"
                value={idUnidadeNegocio}
                onChange={(e) => setIdUnidadeNegocio(e.target.value as number)}
                label="Unidade Negócio *"
              >
                {businessUnitList.map((row: any) => (
                  <MenuItem value={row.id}>{row.nomeFantasia}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              value={inputValue}
              onChange={(event: any, newValue: string | null) => {
                setInputValue(newValue);
              }}
              id="controllable-states-dem"
              options={pontoVendaTitleList.map((option: any) => option.titulo)}
              style={{ width: '100%' }}
              renderInput={(params) => (
                <TextField {...params} label="Ponto Venda" required />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="UserNewcon"
              name="userNewcon"
              label="Usuário Newcon"
              fullWidth
              autoComplete="userNewcon"
              value={userNewcon}
              onChange={(e) => setuserNewcon(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="LoginNewcon"
              name="LoginNewcon"
              label="Login Newcon"
              fullWidth
              autoComplete="loginNewcon"
              value={loginNewcon}
              onChange={(e) => setLoginNewcon(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="password"
              id="SenhaNewcon"
              name="senhaNewcon"
              label="Senha Newcon"
              fullWidth
              autoComplete="senhaNewcon"
              value={senhaNewcon}
              onChange={(e) => setSenhaNewcon(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="loginWatchDoc"
              name="loginWatchDoc"
              label="Login WatchDoc"
              fullWidth
              autoComplete="loginNewcon"
              value={loginWatchDoc}
              onChange={(e) => setLoginWatchDoc(e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreate}
              disabled={loading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export const CreateUser = UserRegistrationComponent;
